module.exports = __webpack_public_path__ + "img/home_swiper_03.eae92d29.jpg";